import { z } from "zod";

export const environmentSchema = z.object({
  VITE_ENTRA_TENANT_ID: z.string(),
  VITE_APP_REGISTRATION_ID: z.string(),
  VITE_VERSION_AND_DEPLOYMENT_DATETIME: z.string(),
});

export type Environment = z.infer<typeof environmentSchema>;

export const env = environmentSchema.parse(import.meta.env);
